var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1C2AEEB7-39B5-4F21-A3FB-92EEA8561FD2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Errors",
    transform: "translate(-622.000000, -313.000000)",
    fill: "#BE1111",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error",
    transform: "translate(622.585527, 313.392388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9683144,0 C17.0305789,0 21.9366289,4.90562148 21.9366289,10.9683144 C21.9366289,17.0305789 17.0310074,21.9366289 10.9683144,21.9366289 C4.90604993,21.9366289 0,17.0310074 0,10.9683144 C0,4.90604993 4.90562148,0 10.9683144,0 Z M10.9683144,1.71379913 C5.85326671,1.71379913 1.71379913,5.85292395 1.71379913,10.9683144 C1.71379913,16.0833622 5.85292395,20.2228297 10.9683144,20.2228297 C16.0833622,20.2228297 20.2228297,16.0837049 20.2228297,10.9683144 C20.2228297,5.85326671 16.0837049,1.71379913 10.9683144,1.71379913 Z M10.9683144,13.8029382 C11.6072054,13.8029382 12.1251289,14.3208617 12.1251289,14.9597526 C12.1251289,15.5986436 11.6072054,16.116567 10.9683144,16.116567 C10.3294235,16.116567 9.81150002,15.5986436 9.81150002,14.9597526 C9.81150002,14.3208617 10.3294235,13.8029382 10.9683144,13.8029382 Z M10.9683144,5.52173226 C11.4415801,5.52173226 11.825214,5.9053662 11.825214,6.37863183 L11.825214,6.37863183 L11.825214,11.8967651 C11.825214,12.3700307 11.4415801,12.7536647 10.9683144,12.7536647 C10.4950488,12.7536647 10.1114149,12.3700307 10.1114149,11.8967651 L10.1114149,11.8967651 L10.1114149,6.37863183 C10.1114149,5.9053662 10.4950488,5.52173226 10.9683144,5.52173226 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.d95e2fad2e40d8bb981e573aaa80e035.svg";
export { ForwardRef as ReactComponent };